import { lazy } from 'react';
import { useAppSelector } from 'app/store';
import { Navigate, Route, Routes } from 'react-router-dom';
import { viewerModel } from 'entities/viewer';
import { PrivateLayout } from 'layouts/private-layout';
import CreateNews from 'features/news/createNews/CreateNews';
import UpdateNews from 'features/news/updateNews/UpdateNews';
import InfoNews from 'features/news/infoNews/InfoNews';
import CreateRvdRequest from 'features/rvd/createRvdRequest/CreateRvdRequest';
import LoadRvd from 'features/rvd/loadRvd/LoadRvd';
import RvdArchiveInfo from 'features/rvd/rvdArchiveInfo/RvdArchiveInfo';
import CreateOvertimeRequest from 'features/overtime/createOvertimeRequest/CreateOvertimeRequest';
import CreateFaq from 'features/FAQ/createFaq/CreateFaq';
import InfoFaq from 'features/FAQ/infoFaq/InfoFaq';
import UpdateFaq from 'features/FAQ/updateFaq/UpdateFaq';
import AcceptSettings from 'features/vacationsSchedule/accept-settings/AcceptSettings';
import UpdateRvd from 'features/rvd/updateRvd/UpdateRvd';
import UpdateOvertime from 'features/overtime/updateOvertime/UpdateOvertime';
import LoadOvertime from 'features/overtime/loadOvertime/LoadOvertime';
import OvertimeArchiveInfo from 'features/overtime/overtimeArchiveInfo/OvertimeArchiveInfo';
import InfoPoll from 'features/poll/infoPoll/InfoPoll';
import UpdatePoll from 'features/poll/updatePoll/UpdatePoll';
import CreatePoll from 'features/poll/createPoll/CreatePoll';
import ReferencesPage from './references';
import VacationsPage from './vacations';
import VacationsSchedulePage from './vacations-schedule';
import ReportsPage from './reports';
import ControlsPage from './controls';
import ConsultationsPage from './consultations';
import VacationsSubordinationPage from './vacationsSubordination';
import ConsultationsSubordinationPage from './consultationsSubordination';
import ConsultationUserPage from './consultationUser';
import ReferencesUserPage from './referencesUser';
import ReferencesSubordinationPage from './referencesSubordination';
import ReferencesUserArchivePage from './referencesUserArchive';
import ConsultationUserArchivePage from './consultationUserArchive';
import VacationsUserArchivePage from './vacationsUserArchive';
import VacationsUserPage from './vacationsUser';
import VacationsUserSubordinationArchivePage from './vacationsUserSubordinatesArchive';
import ConsultationUserSubordinationArchivePage from './consultationUserSubordinationArchive';
import ReferencesUserSubordinationArchivePage from './referencesUserSubordinatesArchive';
import AbsencePage from './absence';
import AbsenceUserPage from './absenceUser';
import AbsenceUserArchivePage from './absenceUserArchive';
import AbsenceSubordinationPage from './absenceSubordination';
import AbsenceUserSubordinationArchivePage from './absenceUserSubordinatesArchive';
import SubstitutionsPage from './substitutions';
import AbsenceImportPage from './absenceImport';
import NewsPage from './news';
import HolidayWorkPage from './holidayWork';
import OvertimePage from './overtime';
import FaqPage from './FAQ';
import Poll from './poll';
import VacationsApplicationPage from './vacations-application';
import VacationsApplicationsUserPage from './vacationsApplicationsUser';
import ChangePass from './change-pass';
import DayOffPage from './dayOff';
import DayOffUserPage from './dayOffUser';
import CancelDayOffPage from './cancelDayOff';
import CancelDayOffUserPage from './cancelDayOffUser';
import AbsenceSupervisorPage from './absenceSupervisor';
import VacationScheduleSubordinatesPage from './vacationScheduleSubordinates';
import VacationsScheduleSubordinatesUserPage from './vacationScheduleSubordinatesUser';
import DayOffSupervisorPage from './dayOffSupervisor';
import DayOffCancelSupervisorPage from './dayOffCancelSupervisor';

const HomePage = lazy(() => import('./home'));
const AuthPage = lazy(() => import('./auth'));
/**
 * Роутинг приложения
 */

const Routing = () => {
  const isAuth = useAppSelector(viewerModel.credentials.selectors.getIsAuth);

  if (!isAuth) {
    return (
      <Routes>
        <Route path="/login" element={<AuthPage />} />
        <Route path="/login/changePass" element={<ChangePass />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<PrivateLayout />}>
        <Route index element={<HomePage />} />

        <Route path="/references" element={<ReferencesPage />} />
        <Route path="/references/:id" element={<ReferencesUserPage />} />
        <Route path="/references/user/subordination/:id" element={<ReferencesSubordinationPage />} />
        <Route path="/references/archive/user/:id" element={<ReferencesUserArchivePage />} />
        <Route path="/references/archive/user/subordination/:id" element={<ReferencesUserSubordinationArchivePage />} />

        <Route path="/consultations" element={<ConsultationsPage />} />
        <Route path="/consultations/:id" element={<ConsultationUserPage />} />
        <Route path="/consultations/user/subordination/:id" element={<ConsultationsSubordinationPage />} />
        <Route path="/consultations/archive/user/:id" element={<ConsultationUserArchivePage />} />
        <Route
          path="/consultations/archive/user/subordination/:id"
          element={<ConsultationUserSubordinationArchivePage />}
        />

        <Route path="/vacation" element={<VacationsPage />} />
        <Route path="/vacation-schedule" element={<VacationsSchedulePage />} />
        <Route path="/vacation-schedule/accept-settings" element={<AcceptSettings />} />
        <Route path="/vacation/user/:id" element={<VacationsUserPage />} />
        <Route path="/vacation/user/subordination/:id" element={<VacationsSubordinationPage />} />
        <Route path="/vacation/archive/user/subordination/:id" element={<VacationsUserSubordinationArchivePage />} />
        <Route path="/vacation/archive/user/:id" element={<VacationsUserArchivePage />} />

        <Route path="/vacation-schedule-subordinates" element={<VacationScheduleSubordinatesPage />} />
        <Route path="/vacation-schedule-subordinates/user/:id" element={<VacationsScheduleSubordinatesUserPage />} />

        <Route path="/dayoff" element={<DayOffPage />} />
        <Route path="/dayoffUser/:id" element={<DayOffUserPage />} />

        <Route path="/dayoff-supervisor" element={<DayOffSupervisorPage />} />
        <Route path="/dayoff-cancel-supervisor" element={<DayOffCancelSupervisorPage />} />

        <Route path="/cancelDayOff" element={<CancelDayOffPage />} />
        <Route path="/cancelDayOff/cancelDayOffUser/:id" element={<CancelDayOffUserPage />} />

        <Route path="/vacation-application" element={<VacationsApplicationPage />} />
        <Route path="/vacation-application/user/:id" element={<VacationsApplicationsUserPage />} />

        <Route path="/reports" element={<ReportsPage />} />

        <Route path="/controls" element={<ControlsPage />} />

        <Route path="/absence" element={<AbsencePage />} />
        <Route path="/absence/user/:id" element={<AbsenceUserPage />} />
        <Route path="/absence/user/subordination/:id" element={<AbsenceSubordinationPage />} />
        <Route path="/absence/archive/user/subordination/:id" element={<AbsenceUserSubordinationArchivePage />} />
        <Route path="/absence/archive/user/:id" element={<AbsenceUserArchivePage />} />
        <Route path="/absence/import" element={<AbsenceImportPage />} />

        <Route path="/absence-supervisor" element={<AbsenceSupervisorPage />} />

        <Route path="/substitutions" element={<SubstitutionsPage />} />

        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/create" element={<CreateNews />} />
        <Route path="/news/update/:id" element={<UpdateNews />} />
        <Route path="/news/info/:id" element={<InfoNews />} />

        <Route path="/faq" element={<FaqPage />} />
        <Route path="/faq/create" element={<CreateFaq />} />
        <Route path="/faq/update/:id" element={<UpdateFaq />} />
        <Route path="/faq/info/:id" element={<InfoFaq />} />

        <Route path="/polls" element={<Poll />} />
        <Route path="/polls/create" element={<CreatePoll />} />
        <Route path="/polls/update/:id" element={<UpdatePoll />} />
        <Route path="/polls/info/:id" element={<InfoPoll />} />

        <Route path="/rvd" element={<HolidayWorkPage />} />
        <Route path="/rvd/new" element={<CreateRvdRequest />} />
        <Route path="/rvd/load/:id" element={<LoadRvd />} />
        <Route path="/rvd/update/:id" element={<UpdateRvd />} />
        <Route path="/rvd/archive/:id" element={<RvdArchiveInfo />} />

        <Route path="/overtime" element={<OvertimePage />} />
        <Route path="/overtime/new" element={<CreateOvertimeRequest />} />
        <Route path="/overtime/load/:id" element={<LoadOvertime />} />
        <Route path="/overtime/update/:id" element={<UpdateOvertime />} />
        <Route path="/overtime/archive/:id" element={<OvertimeArchiveInfo />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default Routing;
